import * as i0 from '@angular/core';
import { InjectionToken, makeEnvironmentProviders, inject, isDevMode, PLATFORM_ID, Injectable, Inject, Directive } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { first, concat, interval, filter } from 'rxjs';
import * as i1 from '@angular/service-worker';
const APP_VERSION_INTERVAL_TOKEN = new InjectionToken('[ngxAppVersion] Interval');
const APP_VERSION_DRY_RUN_TOKEN = new InjectionToken('[ngxAppVersion] Dry run');
const APP_VERSION_ON_UPDATE_TOKEN = new InjectionToken('[ngxAppVersion] On Update');
const provideUpdateApp = options => {
  return makeEnvironmentProviders([{
    provide: APP_VERSION_INTERVAL_TOKEN,
    useValue: options.interval
  }, {
    provide: APP_VERSION_DRY_RUN_TOKEN,
    useValue: options.dryRun
  }, {
    provide: APP_VERSION_ON_UPDATE_TOKEN,
    useFactory: options.onUpdateFactory
  }]);
};
let NgxUpdateAppService = /*#__PURE__*/(() => {
  class NgxUpdateAppService {
    constructor(platformId, appRef, updates) {
      this.platformId = platformId;
      this.appRef = appRef;
      this.updates = updates;
      this.interval = inject(APP_VERSION_INTERVAL_TOKEN);
      this.dryRun = inject(APP_VERSION_DRY_RUN_TOKEN) || false;
      this.onUpdate = inject(APP_VERSION_ON_UPDATE_TOKEN);
    }
    checkForUpdates() {
      if (this.dryRun) {
        this.onUpdate();
      } else if (this.isEnabled) {
        const appIsStable$ = this.appRef.isStable.pipe(first(isStable => isStable === true));
        const pollInterval$ = concat(appIsStable$, interval(this.interval));
        pollInterval$.subscribe(() => this.updates.checkForUpdate());
        this.updates.versionUpdates.pipe(filter(e => e.type === 'VERSION_READY')).subscribe(() => {
          this.onUpdate();
        });
      }
    }
    get isEnabled() {
      return typeof window !== 'undefined' && 'navigator' in window && 'serviceWorker' in navigator && isPlatformBrowser(this.platformId) && !isDevMode(), this.updates.isEnabled;
    }
    static {
      this.ɵfac = function NgxUpdateAppService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgxUpdateAppService)(i0.ɵɵinject(PLATFORM_ID), i0.ɵɵinject(i0.ApplicationRef), i0.ɵɵinject(i1.SwUpdate));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NgxUpdateAppService,
        factory: NgxUpdateAppService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NgxUpdateAppService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxUpdateAppDirective = /*#__PURE__*/(() => {
  class NgxUpdateAppDirective {
    constructor(update) {
      this.update = update;
    }
    ngOnInit() {
      this.update.checkForUpdates();
    }
    static {
      this.ɵfac = function NgxUpdateAppDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgxUpdateAppDirective)(i0.ɵɵdirectiveInject(NgxUpdateAppService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgxUpdateAppDirective,
        selectors: [["", "ngxUpdateApp", ""]],
        standalone: true
      });
    }
  }
  return NgxUpdateAppDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-update-app
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APP_VERSION_DRY_RUN_TOKEN, APP_VERSION_INTERVAL_TOKEN, APP_VERSION_ON_UPDATE_TOKEN, NgxUpdateAppDirective, NgxUpdateAppService, provideUpdateApp };
